export const RESTAURANT_DETAILS_REQUEST = 'RESTAURANT_DETAILS_REQUEST'
export const RESTAURANT_DETAILS_SUCCESS = 'RESTAURANT_DETAILS_SUCCESS'
export const RESTAURANT_DETAILS_FAIL = 'RESTAURANT_DETAILS_FAIL'
